/**
 * Photo localization helpers.
 *
 * Backend exposes `title_i18n` and `description_i18n` as { en, es } maps
 * (lazy-populated by /api/photos/{id}/translate). Frontend prefers the
 * viewer's UI language and falls back to the canonical title/description.
 *
 * `needsTranslation(photo, lang)` returns true when the viewer's language
 * is missing for either field AND there's source text to translate. The
 * PhotoDetail page uses this to fire-and-forget the translate endpoint.
 */
export function localizedTitle(photo, lang) {
  if (!photo) return "";
  const t = photo.title_i18n && photo.title_i18n[lang];
  return (t && t.trim()) || photo.title || "";
}

export function localizedDescription(photo, lang) {
  if (!photo) return "";
  const d = photo.description_i18n && photo.description_i18n[lang];
  return (d && d.trim()) || photo.description || "";
}

export function needsTranslation(photo, lang) {
  if (!photo || !lang) return false;
  if (lang !== "en" && lang !== "es") return false;
  const titleMissing =
    (photo.title || "").trim() &&
    !((photo.title_i18n && photo.title_i18n[lang]) || "").trim();
  const descMissing =
    (photo.description || "").trim() &&
    !((photo.description_i18n && photo.description_i18n[lang]) || "").trim();
  return Boolean(titleMissing || descMissing);
}
